import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllFlow = createAsyncThunk(
  "DropDowns/GetAllFlow",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDownsManager/GetAllFlow");

      const data = response.data.result;
      console.log(data, "dataaaa");

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownFlow = createSlice({
  name: "DropDownFlow",
  initialState: {
    DropDownFlow: [],
    loadingDropDownFlow: false,
    errorDropDownFlow: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllFlow.pending, (state, action) => {
        state.loadingDropDownFlow = true;
        state.DropDownFlow = action.payload;
        state.errorDropDownFlow = null;
      })
      .addCase(GetAllFlow.fulfilled, (state, action) => {
        state.loadingDropDownFlow = false;
        state.DropDownFlow = action.payload;
      })
      .addCase(GetAllFlow.rejected, (state, action) => {
        state.loadingDropDownFlow = false;
        state.errorDropDownFlow = action.payload;
      });
  },
});

export default DropDownFlow.reducer;
